import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import RegistrationForm from './components/RegistrationForm';
import LegalLinks from './components/LegalLinks';

const RegistrationScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen">
      <div className="fixed inset-0 -z-10 bg-[url('/assets/images/medical.jpg')] bg-cover bg-center bg-no-repeat" />
      <div className="fixed inset-0 -z-10 bg-black/75" />

      {/* Header */}
      <header className="relative z-10 bg-white/5 backdrop-blur-lg border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button
              className="flex items-center space-x-3 group"
              onClick={() => navigate('/')}
            >
              <img
                src="/assets/images/graftcounter-logo.png"
                alt="Graft Counter Logo"
                className="w-9 h-9 object-contain"
              />
              <span className="text-xl font-semibold text-white group-hover:text-white/80 transition-colors">
                Graft Counter
              </span>
            </button>

            <button
              onClick={() => navigate('/login-screen')}
              className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors font-medium px-4 py-2 border border-white/10 hover:border-white/25 rounded-lg"
            >
              <Icon name="ArrowLeft" size={14} />
              Back to Login
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 flex-1 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md mx-auto">
          <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl shadow-xl p-8">

            {/* Form Header */}
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-blue-500/15 rounded-full flex items-center justify-center mx-auto mb-4 border border-blue-400/20">
                <Icon name="UserPlus" size={32} color="#60A5FA" />
              </div>
              <h1 className="text-2xl font-light text-white tracking-tight mb-2">
                Create Your Account
              </h1>
              <p className="text-slate-300 text-sm">
                Join the leading platform for hair transplant graft analysis
              </p>
            </div>

            {/* Registration Form */}
            <RegistrationForm />

            {/* Login Link */}
            <div className="mt-8 text-center">
              <p className="text-sm text-slate-400">
                Already have an account?{' '}
                <button
                  onClick={() => navigate('/login-screen')}
                  className="text-blue-400 hover:text-blue-300 font-medium underline transition-colors duration-200"
                >
                  Sign in here
                </button>
              </p>
            </div>

            {/* Legal Links */}
            <div className="mt-8">
              <LegalLinks />
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 bg-white/5 backdrop-blur-lg border-t border-white/10 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <img
                src="/assets/images/graftcounter-logo.png"
                alt="Graft Counter Logo"
                className="w-6 h-6 object-contain"
              />
              <span className="text-sm font-medium text-white">
                Graft Counter
              </span>
            </div>
            <div className="text-sm text-slate-400">
              © {new Date()?.getFullYear()} Graft Counter. All rights reserved.
              Built for medical professionals.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RegistrationScreen;
